import api from 'services/technical-visit/technical-visit'

export const handleRemoveMaintenanceInspection = async (id: string, equipmentId: string, inspectionId: string) => {
  let res = await api.removeMaintenanceInspection(id, equipmentId, inspectionId)

  return res?.data?.success
}
